import { render } from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { RouteErrorBoundary } from '@components/route-error-boundary';
import { setSentryContext, startSentry } from '@utils/sentry';

import { App } from 'components/app';

import { config } from './app-config';

import '@styles/variables.css';
import '@styles/reset.css';

if (config.SENTRY_URL) {
  startSentry(config.SENTRY_URL);
  setSentryContext('build', {
    buildDate: process.env.__BUILD_DATE__,
    buildRef: process.env.__BUILD_REF__,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const root = (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter basename={process.env.VITE_BASE_PATH || ''}>
      <Routes>
        <Route path="/:company/:id" element={<App />} errorElement={<RouteErrorBoundary />} />
      </Routes>
    </BrowserRouter>
  </QueryClientProvider>
);

render(root, document.getElementById('root'));
